module.exports = __webpack_public_path__ + "img/1595926019829.b53fc86c.jpg";